import UploadFile from "components/UploadFile";
import React from "react";

const HomePage = () => {
  return <UploadFile />;
};

export default HomePage;
